<!-- does not handle Form Element sub-objects -->
<template>
  <!--  v-if is in case the form async fetch hasn't been received yet-->
  <loading :loading="!Boolean(handler.dynamicInput)">
    <template #loading>
      <collapsible-section
        :control-name="dropdownControlId"
        :id="dropdownControlId"
        :is-open="false"
        disabled
        class="collapse-item"
      >
        <template #section-header>
          <xpinner />
        </template>
      </collapsible-section>
    </template>
    <template #loaded>
      <collapsible-section
        v-if="handler.dynamicInput"
        class="collapse-item"
        :id="`dynamicInputCollapse-${handler.dynamicInput.client_id}-${dropdownControlId}`"
        control-name="dynamicInputCollapse"
        :is-open="false"
      >
        <template #section-header>
          <row>
            <prefix>
              <icon :glyph="varIOClass(handler.variable)" />
            </prefix>
            <column>
              {{ handler.rootHeaderOrDefault }}
            </column>
          </row>
        </template>

        <template #section-contents>
          <dynamic-input-object-data
              :handler="handler"
              :q="q"
              :dynamic-input-object="handler.dynamicInput"
              :path="handler.basePath"
              :parent-tree-context="computedChildTreeContext"
              @select="select"
          ></dynamic-input-object-data>
        </template>
      </collapsible-section>
    </template>
  </loading>
</template>

<script lang="ts">
  import Vue from 'vue'
  import handlerComponentMixin from '~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin'
  import {IDynamicTreeContext} from "~/interfaces/dynamicFieldsInterfaces"
  import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin'
  import CollapsibleSection from '~/components/dynamicFieldsTrees/handlerComponents/common/collapsible-section.vue'
  import DynamicElementMixin from '~/components/dynamicFieldsTrees/handlerComponents/common/dynamic-element-mixin.vue'
  import ProcessFlowDynamicInputFieldsHandler from '~/models/dynamicFields/handlers/processFlows/processFlowDynamicInputFieldsHandler'
  import DynamicInputObjectData from "~/components/dynamicFieldsTrees/handlerComponents/dynamic-input-object-data.vue";
  import dropdownControlMixin from '~/components/dynamicFieldsTrees/mixins/dropdownControlMixin'
  import FieldItem from '~/components/dynamicFieldsTrees/handlerComponents/common/field-item.vue';

  export default Vue.extend({
    mixins: [
      handlerComponentMixin,
      handlerTreeContextMixin,
      DynamicElementMixin,
      dropdownControlMixin
    ],
    components: {
      CollapsibleSection,
      DynamicInputObjectData,
      FieldItem,
    },
    props: {
      handler: {
        type: Object as () => ProcessFlowDynamicInputFieldsHandler,
        required: true,
      },
      restrictResultsToParentContext: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      treeContext(): Partial<IDynamicTreeContext> {
        return {
          parent: this.handler.dynamicInput,
          isTopLevelCollectionAssigned: false,
        }
      },
    },
  })
</script>